
import React, { useState, useEffect } from 'react';
import { ChevronLeft, Edit2, Tag, ChevronDown, ChevronUp, Plus, Minus, Trash2, X, Clock } from 'lucide-react';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
import CustomDialog from "../../CustomDialog";
import addressConfig from "../../Configurations/addressConfig.json";
import TIME_SLOTS from "../../Configurations/timeslots.json";
import { apiRequest } from '../../fetchSetup';
import {
  Checkbox, FormControlLabel,Typography
} from "@mui/material";
import axios from 'axios';

const COMMUNITY_OPTIONS = addressConfig.communities;
const BLOCK_OPTIONS = addressConfig.blocks;

const API_URL=process.env.REACT_APP_API_BASE_URL
const MedicineDeliveryAddressScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {          
    cart: initialCart,
    orderType,
    totalAmount: initialTotal,
    patientDetails,
    prescriptionFile,
  } = location.state || {};

  // ─── AYUJA pricing data ────────────────────────────────────────────────────

  const ayujaData = React.useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem('ayujaPricing') || '{}');
    } catch { return {}; }
  }, []);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Promo
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [promoLoading, setPromoLoading] = useState(false);
  const [showAvailablePromos, setShowAvailablePromos] = useState(false);
  const [availablePromos, setAvailablePromos] = useState([]);

  // Cart — initialised from location.state first, then sessionStorage fallback
  const [cart, setCart] = useState(() => {
    if (initialCart && initialCart.length > 0) return initialCart;
    try {
      const saved = sessionStorage.getItem('pharmacyCart');
      const parsed = saved ? JSON.parse(saved) : null;
      return Array.isArray(parsed) && parsed.length > 0 ? parsed : [];
    } catch { return []; }
  });

  const [formData, setFormData] = useState({
    full_name: "", phone: "", community_name: "", address_line1: "",
    address_line2: "", landmark: "", city: "", state: "", pincode: "",
    address_type: "home", delivery_time_option: "anytime", delivery_time: "",
  });
  const [originalFormData, setOriginalFormData] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedDate, setSelectedDate] = useState("");
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  // Subscription
  const [subscriptionBenefits, setSubscriptionBenefits] = useState(null);
  const [subscriptionDiscount, setSubscriptionDiscount] = useState(0);
  const [loadingSubscription, setLoadingSubscription] = useState(false);


const [walletBalance, setWalletBalance] = useState(0);
const [useWallet, setUseWallet] = useState(false);
const [loadingWallet, setLoadingWallet] = useState(false);
const [acceptedTerms,setAcceptedTerms]=useState(false)
const [maxWalletDeduction, setMaxWalletDeduction] = useState(0); 
const [maxWalletPoints, setMaxWalletPoints] = useState(0); 

const [redemptionEnabled, setRedemptionEnabled] = useState(true); 


  // ─── ALL TOTALS — computed directly from cart.discounted_price ─────────────
  const deliveryCharge =sessionStorage.getItem("community") !== "Honer Vivantis"
    ? Number(process.env.REACT_APP_DELIVERY_CHARGE) || 0:0;
  const discountAmount = appliedPromo ? appliedPromo.discount : 0;

  const mrpTotal = cart.reduce((s, i) => s + (i.price || 0) * i.quantity, 0);
  const sellingTotal = cart.reduce((s, i) => s + (i.discounted_price || i.price || 0) * i.quantity, 0);
  const ayujaSavings = mrpTotal - sellingTotal;
  const ayujaDiscPct = mrpTotal > 0 ? (ayujaSavings / mrpTotal * 100).toFixed(1) : "0.0";

  // Per-item discount % (uniform across order from AYUJA engine)
  const perItemDiscPct = mrpTotal > 0 ? (ayujaSavings / mrpTotal) * 100 : 0;

  // Alpha: derived from stored base_price on cart items
  const orderBP = cart.reduce((s, i) => s + (i.base_price || 0) * i.quantity, 0);
  const orderMaxDisc = mrpTotal - orderBP;
  const orderMaxDiscPct = mrpTotal > 0 ? (orderMaxDisc / mrpTotal) * 100 : 0;
  const alphaValue = orderMaxDiscPct > 0 ? perItemDiscPct / orderMaxDiscPct : 0;

  // Cap warning: if applied discount < configured (20%) by more than tolerance
  const configuredDiscPct = 20;
  const wasCapped = perItemDiscPct < configuredDiscPct - 0.5;
  const [communities, setCommunities] = useState([]);
  


  // ─── Add unique IDs to cart items (for updateQuantity keying) ─────────────
  useEffect(() => {
    const community=sessionStorage.getItem('communities')
   const parsedCommunities = JSON.parse(community);

    setCommunities(parsedCommunities)
    setCart(prev =>
      prev.map((item, index) => ({
        ...item,
        id: item.id || `${item.medicine_id}_${index}_${Date.now()}`,
      }))
    );
  }, []);

  // ─── Subscription fetch ────────────────────────────────────────────────────
  useEffect(() => {
    const fetchSubscriptionBenefits = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) return;
      const apiBaseUrl = process.env.REACT_APP_PRICING_API;
      if (!apiBaseUrl) return;
      setLoadingSubscription(true);
      try {
        const response = await apiRequest(`${apiBaseUrl}/check-benefits/${userId}`, {
          method: "GET", headers: { "Content-Type": "application/json" }
        });
        const contentType = response.headers.get("content-type");
        if (!contentType?.includes("application/json") || !response.ok) return;
        const data = await response.json();
        setSubscriptionBenefits(data.success && data.has_subscription ? data : null);
      } catch (error) {
        console.error("Error fetching subscription benefits:", error);
      } finally {
        setLoadingSubscription(false);
      }
    };
    fetchSubscriptionBenefits();
  }, []);

  // ─── Available promos fetch ────────────────────────────────────────────────
  useEffect(() => {
    const fetchAvailablePromos = async () => {
      try {
        const userId = sessionStorage.getItem("userId");
        const response = await apiRequest(
          `${process.env.REACT_APP_APPLY_PROMOTION_API}/available?service_type=medicine&user_id=${userId}`,
          { headers: { "Content-Type": "application/json" } }
        );
        if (response.ok) {
          const data = await response.json();
          if (data.success) setAvailablePromos(data.promotions || []);
        }
      } catch (error) {
        console.error("Error fetching promos:", error);
      }
    };
    fetchAvailablePromos();
  }, []);

  // ─── User / address fetch ──────────────────────────────────────────────────
  useEffect(() => {
    const loadUserData = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) { setUser(null); setLoading(false); return; }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        if (userData) {
          setUser(userData);
          
          const isNonSelf = patientDetails?.patientType === "family" || patientDetails?.patientType === "new";
          if (isNonSelf) {
            const phone = (patientDetails.phone || "").replace(/\D/g, "");

          const normalizedPhone =
            phone.length === 12 && phone.startsWith("91")
              ? phone.slice(2)
              : phone;
            setFormData({
              full_name: patientDetails.name || "",
              phone: normalizedPhone,
              community_name: userData.address?.community_name ,
              address_line1: userData.address?.address_line1 || "",
              address_line2: userData.address?.address_line2 || "",
              landmark: userData.address?.landmark || "",
              city: userData.address?.city || "Hyderabad",
              state: userData.address?.state || "Telangana",
              pincode: userData.address?.pincode || "500046",
              address_type: userData.address?.address_type || "home",
              delivery_time_option: "anytime", delivery_time: "",
            });
          } else if (userData.address?.full_name) {
             const phone = (userData.address.phone || userData.phone || "").replace(/\D/g, "");

              const normalizedPhone =
                phone.length === 12 && phone.startsWith("91")
                  ? phone.slice(2)
                  : phone;
            setFormData({
              full_name: userData.address.full_name || userData.name || "",
              phone: normalizedPhone,
              community_name: userData.address.community_name,
              address_line1: userData.address.address_line1 || "",
              address_line2: userData.address.address_line2 || "",
              landmark: userData.address.landmark || "",
              city: userData.address.city || "Hyderabad",
              state: userData.address.state || "Telangana",
              pincode: userData.address.pincode || "500046",
              address_type: userData.address.address_type || "home",
              delivery_time_option: "anytime", delivery_time: "",
            });
          } else {
            setFormData(prev => ({ ...prev, full_name: userData.name || "", phone: userData.phone || "",community_name: userData.address.community_name || "", city:"Hyderabad",state:"Telangana",pincode: "",address_type:"home"}));
          }
        }
        if ((userData.address.address_line1==="")){
      console.log(formData)
      setIsEditingAddress(true)
    }
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    }
    loadUserData();
    
  }, [patientDetails]);

useEffect(() => {
  const fetchWalletBalance = async () => {
    const userId = sessionStorage.getItem("userId");
    const token = sessionStorage.getItem("token");
    if (!userId || !token) return;
    setLoadingWallet(true);
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_REFERRAL_API}/wallet/balance/${userId}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const contentType = response.headers.get("content-type");
      if (!contentType?.includes("application/json") || !response.ok) {
        console.error("Wallet balance fetch failed:", response.status);
        return;
      }
      const data = await response.json();
      if (data.success) setWalletBalance(data.wallet_balance || 0);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    } finally {
      setLoadingWallet(false);
    }
  };
  fetchWalletBalance();
}, []);




// ─── Wallet redemption preview — respects service % cap + point value ─────
useEffect(() => {
  const fetchRedemptionPreview = async () => {
    const userId = sessionStorage.getItem("userId");
    const token = sessionStorage.getItem("token");
    if (!userId || !token || walletBalance <= 0) return;

    const billBeforeWallet = Math.max(
      0,
      sellingTotal + deliveryCharge - subscriptionDiscount - discountAmount
    );
    if (billBeforeWallet <= 0) {
      setMaxWalletDeduction(0);
      setMaxWalletPoints(0);
      return;
    }

    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_REFERRAL_API}/wallet/redemption-preview`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            service_type: "medicine",
            bill_total: billBeforeWallet,
          }),
        }
      );
      const contentType = response.headers.get("content-type");
      if (!contentType?.includes("application/json") || !response.ok) return;
      const data = await response.json();
      if (data.success) {
        setMaxWalletDeduction(data.max_redeemable_amount || 0);
        setMaxWalletPoints(data.max_redeemable_points || 0);
        setRedemptionEnabled(!!data.redemption_enabled); 
      }
    } catch (error) {
      console.error("Error fetching wallet redemption preview:", error);
    }
  };
  fetchRedemptionPreview();
}, [sellingTotal, deliveryCharge, subscriptionDiscount, discountAmount, walletBalance]); 

useEffect(() => {   // reset if admin disables mid-session
  if (!redemptionEnabled && useWallet) setUseWallet(false);
}, [redemptionEnabled]);






  // ─── Promo re-validate on cart change ─────────────────────────────────────
  const justAppliedPromo = React.useRef(false);

  useEffect(() => {
    if (appliedPromo) validateAppliedPromo();
  }, [cart]);  // eslint-disable-line

  // ─── Subscription discount ─────────────────────────────────────────────────
  useEffect(() => {
    if (subscriptionBenefits?.has_subscription) {
      const pct = subscriptionBenefits.benefits.medicine_discount || 0;
      setSubscriptionDiscount((sellingTotal * pct) / 100);
    } else {
      setSubscriptionDiscount(0);
    }
  }, [cart, subscriptionBenefits]);  // eslint-disable-line


//   const amountBeforeWallet = Math.max(0, sellingTotal + deliveryCharge - subscriptionDiscount - discountAmount);
// const walletDeduction = useWallet ? Math.min(walletBalance, amountBeforeWallet) : 0;
// const finalAmount = Math.max(0, amountBeforeWallet - walletDeduction); // replaces your old finalAmount
// const remainingWallet = walletBalance - walletDeduction;

const amountBeforeWallet = Math.max(0, sellingTotal + deliveryCharge - subscriptionDiscount - discountAmount);
const walletDeduction = useWallet ? maxWalletDeduction : 0;   // ← backend-verified, respects % cap + point value
const finalAmount = Math.max(0, amountBeforeWallet - walletDeduction);
const remainingWallet = walletBalance - maxWalletPoints;       // ← points remaining, not ₹




  // const finalAmount = Math.max(0, sellingTotal + deliveryCharge - subscriptionDiscount - discountAmount);

  // ─── Promo helpers ─────────────────────────────────────────────────────────
  const applyPromoCode = async (code) => {
    setPromoLoading(true);
    try {
      const userId = sessionStorage.getItem("userId");
      const response = await apiRequest(`${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ promo_code: code.toUpperCase(), service_type: "medicine", order_price: sellingTotal, user_id: userId }),
      });
      const data = await response.json();
      if (data.success) {
        justAppliedPromo.current = true;
        setAppliedPromo({ code: data.promo_code, discount: data.discount_amount, title: data.title });
        setPromoCode("");
        setShowAvailablePromos(false);
        setDialogMessage(data.message || "Promo code applied successfully!");
        setDialogOpen(true);
      } else {
        setDialogMessage(data.error || "Invalid promo code");
        setDialogOpen(true);
      }
    } catch {
      setDialogMessage("Failed to apply promo code. Please try again.");
      setDialogOpen(true);
    } finally {
      setPromoLoading(false);
    }
  };
const handleSaveAddress=async(addressData)=>{
     try {
      
      const token = sessionStorage.getItem("token");
      
      if (!token) {
        console.error("No authentication token found");
        return false;
      }

      const response = await apiRequest(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          address:{full_name: addressData.full_name,
                phone: addressData.phone,
                community_name: addressData.community_name ||"",
                address_line1: addressData.address_line1 ||"",
                address_line2: addressData.address_line2 ||"",
                city: addressData.city ||"",
                state: addressData.state ||"",
                pincode: addressData.pincode ||""
              }
        })
      });

      const data = await response.json();
  }
  catch (error) {
      console.error("Error Saving Address:", error);
      return false;
    }
}
  const validateAppliedPromo = async () => {
    if (!appliedPromo) return;
    if (justAppliedPromo.current) { justAppliedPromo.current = false; return; }
    try {
      const userId = sessionStorage.getItem("userId");
      const response = await apiRequest(`${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ promo_code: appliedPromo.code, service_type: "medicine", order_price: sellingTotal, user_id: userId }),
      });
      const data = await response.json();
      if (!data.success) {
        setAppliedPromo(null);
        setDialogMessage(`Promo "${appliedPromo.code}" removed. ${data.error || "Cart no longer meets requirements."}`);
        setDialogOpen(true);
      } else if (data.discount_amount !== appliedPromo.discount) {
        setAppliedPromo({ code: data.promo_code, discount: data.discount_amount, title: data.title });
      }
    } catch {
      setAppliedPromo(null);
    }
  };

  const removePromoCode = () => {
    setAppliedPromo(null);
    setDialogMessage("Promo code removed");
    setDialogOpen(true);
  };

  const recalculateCart = async (updatedCart) => {
  try {
    const response = await apiRequest(
              `${process.env.REACT_APP_MEDICINE_API_URL}/calculate-order-price`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: updatedCart.map(i => ({
                    medicine_id: i.medicine_id,
                    quantity: i.quantity,
                  })),
                }),
              }
            );
    
            if (!response.ok) {
              console.error('AYUJA fetch failed:', response.status, await response.text());
              return;
            }
    

    const pricing = await response.json();

    const mergedCart = updatedCart.map(item => {
      const backendItem = pricing.item_breakdown.find(
        x => x.medicine_id === item.medicine_id
      );

      if (!backendItem) return item;
        
      return {
        ...item,
        discounted_price: backendItem.selling_price,
        discount_percentage: backendItem.discount_pct,
        total: backendItem.selling_price * item.quantity,
      };
    });

    setCart(mergedCart);
    sessionStorage.setItem("pharmacyCart", JSON.stringify(mergedCart));

  } catch (err) {
    console.error(err);
  }
};

  // ─── Cart quantity controls ────────────────────────────────────────────────
  const updateQuantity = (itemId, change) => {
    setCart(prevCart => {
      const updatedCart = prevCart
        .map(item => item.id === itemId ? { ...item, quantity: item.quantity + change } : item)
        .filter(item => item.quantity > 0);
      recalculateCart(updatedCart);
      sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
      return updatedCart;
    });
    if (appliedPromo) setAppliedPromo(null);
  };

  const removeItem = (itemId) => {
    setCart(prevCart => {
      const updatedCart = prevCart.filter(item => item.id !== itemId);
      recalculateCart(updatedCart);
      sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
      return updatedCart;
    });
    if (appliedPromo) setAppliedPromo(null);
  };

  // ─── Delivery time helpers ─────────────────────────────────────────────────
  const handleDateChange = (dateString) => {
    setSelectedDate(dateString);
    setSelectedSlot("");
    handleInputChange("delivery_time", "");
    const selected = new Date(dateString);
    const now = new Date();
    const isToday = selected.toDateString() === now.toDateString();
    const slots = TIME_SLOTS.map(slot => ({
      ...slot,
      disabled: isToday && now.getHours() >= slot.end,
    }));
    setAvailableSlots(slots);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: "" }));
  };

  const handleEditAddress = () => { setOriginalFormData({ ...formData }); setIsEditingAddress(true); };
  const handleCancelEdit = () => {
    if (originalFormData) setFormData(originalFormData);
    setErrors({}); setSelectedDate(""); setSelectedSlot(""); setIsEditingAddress(false);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) newErrors.full_name = "Full name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^(\+91)?\d{10}$/.test(formData.phone)) newErrors.phone = 'Please enter a valid 10-digit phone number';
    if (!formData.community_name.trim()) newErrors.community_name = "Community/Society name is required";
    if (!formData.address_line1.trim()) newErrors.address_line1 = "Block/Building is required";
    if (formData.delivery_time_option === "specific") {
      if (!selectedDate) newErrors.selectedDate = "Please select a delivery date";
      if (!formData.delivery_time) newErrors.delivery_time = "Please select a delivery time slot";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const applySubscriptionToOrder = async () => {
    if (!subscriptionBenefits?.has_subscription) return null;
    const userId = sessionStorage.getItem("userId");
    const apiBaseUrl = process.env.REACT_APP_PRICING_API;
    if (!apiBaseUrl) return null;
    try {
      const response = await apiRequest(`${apiBaseUrl}/apply-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId, service_type: "medicine", base_price: sellingTotal }),
      });
      const contentType = response.headers.get("content-type");
      if (!contentType?.includes("application/json") || !response.ok) return null;
      return await response.json();
    } catch { return null; }
  };

  const handleProceed = async () => {
    if (cart.length === 0) { setDialogMessage("Your cart is empty."); setDialogOpen(true); return; }
    if (!validateForm()) { setDialogMessage("Please fill all required fields correctly"); setDialogOpen(true); return; }

    try {
      sessionStorage.setItem('pharmacyCart', JSON.stringify(cart));
      sessionStorage.setItem('pharmacyPatientDetails', JSON.stringify(patientDetails));
      sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(formData));
      if (prescriptionFile) sessionStorage.setItem('pharmacyPrescription', prescriptionFile);

      const subscriptionResponse = await applySubscriptionToOrder();

      const deliveryAddress = {
        ...formData,
        delivery_time_option: formData.delivery_time_option,
        delivery_time: formData.delivery_time_option === "anytime" ? "Anytime" : formData.delivery_time,
        delivery_date: selectedDate,
      };

      const subscriptionData = subscriptionResponse || {
        applied: subscriptionBenefits?.has_subscription || false,
        discount_amount: subscriptionDiscount,
        subscription_name: subscriptionBenefits?.subscription?.name || null,
        subscription_id: subscriptionBenefits?.subscription?.subscription_id || null,
        discount_percent: subscriptionBenefits?.benefits?.medicine_discount || 0,
      };

      navigate("/MedicinePayment", {
        state: {
          cart,
          orderType,
          patientDetails,
          totalAmount: finalAmount,       // ✅ correct final payable
          prescriptionFile,
          deliveryAddress,
          userEmail: user?.email,
          userPhone: formData.phone,
          appliedPromo,
          subscriptionDiscount: subscriptionData.discount_amount,
          promoDiscount: appliedPromo ? appliedPromo.discount : 0,
          promoCode: appliedPromo ? appliedPromo.code : "",
          subscriptionBenefits,
          walletUsed: useWallet,
          walletDeduction,
          walletPointsRequested: useWallet ? maxWalletPoints : 0,  
        },
      });
    } catch (error) {
      console.error("Error in handleProceed:", error);
      setDialogMessage("An error occurred. Please try again.");
      setDialogOpen(true);
    }
  };

  // ─── Styles ────────────────────────────────────────────────────────────────
  const styles = {
    container: { flex: 1, backgroundColor: "#F9FAFB", minHeight: "100vh", paddingBottom: "100px" },
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", backgroundColor: "#fff", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", position: "sticky", top: 0, zIndex: 1000 },
    backButton: { padding: "8px", border: "none", background: "none", cursor: "pointer" },
    headerTitle: { fontSize: "20px", fontWeight: "700", color: "#111827", margin: 0 },
    scrollContent: { padding: "16px", maxWidth: "900px", margin: "0 auto", width: "90%" },
    card: { backgroundColor: "#fff", borderRadius: "16px", padding: "20px", marginBottom: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
    cardTitle: { fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "16px", marginTop: 0 },
    cartItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", backgroundColor: "#F9FAFB", borderRadius: "12px", marginBottom: "12px" },
    itemDetails: { flex: 1 },
    itemName: { fontSize: "15px", fontWeight: "600", color: "#111827", marginBottom: "4px" },
    quantityControl: { display: "flex", alignItems: "center", gap: "12px" },
    qtyButton: { width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #D1D5DB", backgroundColor: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
    qtyText: { fontSize: "16px", fontWeight: "600", minWidth: "24px", textAlign: "center" },
    deleteButton: { padding: "8px", border: "none", background: "none", cursor: "pointer", color: "#EF4444" },
    addressSummary: { padding: "16px", backgroundColor: "#F9FAFB", borderRadius: "12px", marginBottom: "12px" },
    editButton: { display: "flex", alignItems: "center", gap: "8px", padding: "10px 16px", background: "linear-gradient(90deg, #006D77 0%, #00838F 100%)", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "600", marginTop: "12px" },
    closeButton: { padding: "8px", border: "none", background: "none", cursor: "pointer", color: "#6B7280", display: "flex", alignItems: "center", gap: "4px", fontSize: "14px", fontWeight: "600" },
    summaryRow: { display: "flex", justifyContent: "space-between", marginBottom: "12px" },
    summaryLabel: { fontSize: "14px", color: "#6B7280" },
    summaryValue: { fontSize: "14px", fontWeight: "600", color: "#111827" },
    divider: { height: "1px", backgroundColor: "#E5E7EB", margin: "12px 0" },
    promoInput: { display: "flex", gap: "8px", marginTop: "12px" },
    input: { flex: 1, border: "1px solid #D1D5DB", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", fontFamily: "inherit" },
    button: { padding: "10px 20px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "14px", fontWeight: "600" },
    primaryButton: { backgroundColor: "#006D77", color: "#fff" },
    secondaryButton: { backgroundColor: "#fff", color: "#006D77", border: "1px solid #006D77" },
    dangerButton: { backgroundColor: "#EF4444", color: "#fff" },
    promoTag: { display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#D1FAE5", color: "#065F46", padding: "8px 12px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", marginTop: "8px" },
    promoCard: { border: "1px solid #E5E7EB", borderRadius: "12px", padding: "16px", marginBottom: "12px", cursor: "pointer" },
    inputGroup: { marginBottom: "20px" },
    label: { fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" },
    required: { color: "#EF4444" },
    formInput: { width: "100%", border: "1px solid #D1D5DB", borderRadius: "8px", padding: "12px 16px", fontSize: "16px", color: "#111827", backgroundColor: "#fff", boxSizing: "border-box", fontFamily: "inherit" },
    inputError: { borderColor: "#EF4444" },
    errorText: { fontSize: "12px", color: "#EF4444", marginTop: "4px" },
    addressTypeButton: { flex: 1, padding: "12px", borderRadius: "8px", border: "1px solid #D1D5DB", textAlign: "center", cursor: "pointer", backgroundColor: "#fff" },
    addressTypeButtonActive: { background: "linear-gradient(90deg, #006D77 0%, #00838F 100%)", borderColor: "#006D77" },
    addressTypeText: { fontSize: "14px", fontWeight: "600", color: "#6B7280" },
    addressTypeTextActive: { color: "#fff" },
    deliverySummary: { marginTop: "16px", padding: "16px", backgroundColor: "#F0FDFA", borderRadius: "12px", border: "1px solid #CCFBF1", display: "flex", alignItems: "flex-start", gap: "12px" },
    deliverySummaryContent: { flex: 1 },
    deliverySummaryLabel: { fontSize: "12px", color: "#6B7280", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.5px" },
    deliverySummaryValue: { fontSize: "16px", fontWeight: "600", color: "#111827", lineHeight: "1.4" },
    buttonContainer: { position: "fixed", bottom: 0, left: 0, right: 0, backgroundColor: "#fff", padding: "16px", boxShadow: "0 -2px 8px rgba(0,0,0,0.1)", zIndex: 1000 },
    proceedButton: { backgroundColor: acceptedTerms ? "#006D77": "#C4C4C4", padding: "16px", borderRadius: "12px", display: "flex", justifyContent: "center", alignItems: "center", border: "none", cursor: "pointer", maxWidth: "900px", margin: "0 auto", width: "100%" },
    proceedButtonText: { color: "#fff", fontSize: "16px", fontWeight: "700", marginRight: "8px" },
    proceedButtonAmount: { color: "#fff", fontSize: "18px", fontWeight: "700" },
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button onClick={() => navigate(-1)} style={styles.backButton}><ChevronLeft size={24} /></button>
          <h1 style={styles.headerTitle}>Delivery Address</h1>
          <div style={{ width: "40px" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backButton}><ChevronLeft size={24} /></button>
        <h1 style={styles.headerTitle}>Delivery Address</h1>
        <div style={{ width: "40px" }} />
      </div>

      <div style={styles.scrollContent}>

        {/* ─── Cart Items ─────────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Cart Items ({cart.length})</h2>
          {cart.map((item) => {
            // Per-item selling price from cart.discounted_price (AYUJA embedded)
            const sellingPrice = item.discounted_price || item.price || 0;
            const mrp = item.price || 0;
            const discPct = mrp > sellingPrice ? ((mrp - sellingPrice) / mrp) * 100 : 0;

            return (
              <div key={item.id} style={styles.cartItem}>
                <div style={styles.itemDetails}>
                  <div style={styles.itemName}>{item.name}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginTop: 2 }}>
                    <span style={{ fontSize: '12px', color: '#9CA3AF',}}>
                      MRP ₹{mrp.toFixed(2)}
                    </span>
                    {/* <span style={{ fontSize: '13px', color: '#16a34a', fontWeight: 600 }}>
                      ₹{sellingPrice.toFixed(2)} each
                    </span> */}
                    {/* {discPct > 0 && (
                      <span style={{ fontSize: '11px', fontWeight: 700, color: '#ea580c', backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 4, padding: '1px 5px' }}>
                        {discPct.toFixed(1)}% OFF
                      </span>
                    )} */}
                  </div>
                  {/* <div style={{ fontSize: '12px', color: '#6B7280', marginTop: 2 }}>
                    Total: ₹{(sellingPrice * item.quantity).toFixed(2)}
                  </div> */}
                </div>
                <div style={styles.quantityControl}>
                  <button onClick={() => updateQuantity(item.id, -1)} style={styles.qtyButton}><Minus size={16} /></button>
                  <span style={styles.qtyText}>{item.quantity}</span>
                  <button onClick={() => updateQuantity(item.id, 1)} style={styles.qtyButton}><Plus size={16} /></button>
                  {cart.length > 1 && (
                    <button onClick={() => removeItem(item.id)} style={styles.deleteButton}><Trash2 size={18} /></button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* ─── Order Summary ───────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Order Summary</h2>

          {/* Per-item breakdown */}
          {cart.map((item, index) => {
            const mrp = item.price || 0;
            const selling = Number(item.discounted_price) || mrp;
            const qty = item.quantity;
            const itemMrpTotal = mrp * qty;
            const itemSellingTotal = selling * qty;
            const itemSavings = itemMrpTotal - itemSellingTotal;
            const itemDiscPct = mrp > 0 ? ((mrp - selling) / mrp) * 100 : 0;

            return (
              <div key={index} style={{ marginBottom: 12, border: '1px solid #E5E7EB', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', backgroundColor: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>{item.name}</div>
                    {item.selling_unit==="loose_allowed"?( <div style={{ fontSize: 12, color: '#6B7280' }}>
                      Qty: {qty}
                    </div>):
                    (<div style={{ fontSize: 12, color: '#6B7280' }}>
                      Qty: {qty}{item.pack_size ? ` • Pack: ${item.pack_size}` : ''}
                    </div>)}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#16a34a' }}>₹{itemSellingTotal.toFixed(2)}</div>
                    {itemDiscPct > 0 && (
                      <div style={{ fontSize: 11, color: '#ea580c', fontWeight: 700, backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 4, padding: '1px 5px', display: 'inline-block', marginTop: 2 }}>
                        {itemDiscPct.toFixed(2)}% OFF
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ padding: '10px 14px', backgroundColor: '#fff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, fontSize: 13 }}>
                    <span style={{ color: '#6B7280' }}>MRP × {qty}</span>
                    <span style={{ color: '#9CA3AF', textDecoration:(item.selling_unit=="loose_allowed" && qty<10)? 'none':'line-through' }}>₹{itemMrpTotal.toFixed(2)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, fontSize: 13 }}>
                    <span style={{ color: '#6B7280' }}>Selling Price × {qty}</span>
                    <span style={{ color: '#111827', fontWeight: 600 }}>₹{itemSellingTotal.toFixed(2)}</span>
                  </div>
                  {itemSavings > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, paddingTop: 6, borderTop: '1px solid #F3F4F6', marginTop: 4 }}>
                      <span style={{ color: '#16a34a', fontWeight: 600 }}>You save</span>
                      <span style={{ color: '#16a34a', fontWeight: 700 }}>₹{itemSavings.toFixed(2)}</span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          <div style={styles.divider} />

          {/* Bill rows */}
          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>MRP Total</span>
            <span style={{ ...styles.summaryValue, color: '#9CA3AF' }}>₹{mrpTotal.toFixed(2)}</span>
          </div>

          {ayujaSavings > 0 && (
            <div style={{ ...styles.summaryRow, backgroundColor: '#f0fdf4', padding: '6px 10px', borderRadius: 6, margin: '4px 0' }}>
              <span style={{ color: '#16a34a', fontWeight: 600, fontSize: 14 }}>🎉 AYUJA Discount ({ayujaDiscPct}% OFF)</span>
              <span style={{ color: '#16a34a', fontWeight: 700 }}>-₹{ayujaSavings.toFixed(2)}</span>
            </div>
          )}

          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Subtotal</span>
            <span style={styles.summaryValue}>₹{sellingTotal.toFixed(2)}</span>
          </div>

          {subscriptionBenefits?.has_subscription && subscriptionDiscount > 0 && (
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: '#16a34a', fontWeight: 600 }}>
                🎁 Subscription ({subscriptionBenefits.benefits.medicine_discount}%)
              </span>
              <span style={{ ...styles.summaryValue, color: '#16a34a' }}>-₹{subscriptionDiscount.toFixed(2)}</span>
            </div>
          )}

          {appliedPromo && (
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: '#d97706', fontWeight: 600 }}>🏷️ Promo ({appliedPromo.code})</span>
              <span style={{ ...styles.summaryValue, color: '#d97706' }}>-₹{appliedPromo.discount.toFixed(2)}</span>
            </div>
          )}

          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Delivery</span>
            <span style={styles.summaryValue}>
              {deliveryCharge === 0
                ? <><span style={{ textDecoration: 'line-through', color: '#9CA3AF' }}>₹50</span>{' '}<span style={{ color: '#16a34a' }}>FREE</span></>
                : `₹${deliveryCharge}`}
            </span>
          </div>
            {useWallet && walletDeduction > 0 && (
              <div style={styles.summaryRow}>
                <span style={{ ...styles.summaryLabel, color: "#006D77", fontWeight: 600 }}>
                  💰 Wallet Applied ({maxWalletPoints.toFixed(0)} Coins)
                </span>
                <span style={{ ...styles.summaryValue, color: "#006D77" }}>
                  -₹{walletDeduction.toFixed(2)}
                </span>
              </div>
            )}


          <div style={styles.divider} />

          <div style={{ ...styles.summaryRow, marginTop: 8 }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>Total Payable</span>
            <span style={{ fontSize: 20, fontWeight: 700, color: '#006D77' }}>₹{finalAmount.toFixed(2)}</span>
          </div>

          {/* Promo section */}
          {!appliedPromo ? (
            <>
              <div style={styles.promoInput}>
                <input
                  type="text" placeholder="Enter promo code" value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                  style={styles.input}
                />
                <button onClick={() => applyPromoCode(promoCode)} disabled={!promoCode || promoLoading}
                  style={{ ...styles.button, ...styles.primaryButton, opacity: !promoCode ? 0.5 : 1 }}>
                  {promoLoading ? "Applying..." : "Apply"}
                  
                </button>
              </div>
              <button
                onClick={() => setShowAvailablePromos(!showAvailablePromos)}
                style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "8px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <Tag size={16} /> View Available Offers
                {showAvailablePromos ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {subscriptionBenefits?.has_subscription && (
                <div style={{ backgroundColor: "#F3E8FF", padding: "12px", borderRadius: "8px", marginTop: "12px", border: "1px solid #DDD6FE" }}>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "#7C3AED" }}>🎉 Active Subscription</div>
                  <div style={{ fontSize: "12px", color: "#6B7280", marginTop: 4 }}>
                    Saving {subscriptionBenefits.benefits.medicine_discount}% on medicine orders
                  </div>
                  <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: 4 }}>
                    {subscriptionBenefits.subscription.days_remaining} days remaining
                  </div>
                </div>
              )}
              {showAvailablePromos && availablePromos.length > 0 && (
                <div style={{ marginTop: "12px" }}>
                  {availablePromos.map((promo, index) => (
                    <div key={index} style={styles.promoCard}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#006D77"; e.currentTarget.style.backgroundColor = "#F0FDFA"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#E5E7EB"; e.currentTarget.style.backgroundColor = "#fff"; }}
                      onClick={() => applyPromoCode(promo.promo_code)}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                        <div>
                          <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "4px" }}>{promo.promo_code}</div>
                          <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "8px" }}>{promo.description}</div>
                          <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
                            Min order: ₹{promo.min_order_value}
                            {promo.max_discount > 0 && ` • Max discount: ₹${promo.max_discount}`}
                          </div>
                        </div>
                        <button style={{ ...styles.button, ...styles.primaryButton, fontSize: "12px", padding: "6px 12px" }}>Apply</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={styles.promoTag}><Tag size={16} />{appliedPromo.code} Applied</div>
              <button onClick={removePromoCode} style={{ ...styles.button, ...styles.dangerButton, fontSize: "12px", padding: "6px 12px" }}>Remove</button>
            </div>
          )}
        </div>


          {walletBalance > 0 && redemptionEnabled && ( 
            <div style={{ marginTop: 16, padding: "16px", border: "1px solid #D6EAF8", borderRadius: 10, background: "#F9FCFF" }}>
              {/* Top Row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15, color: "#006D77" }}>💰 Wallet Balance</div>
                  <div style={{ color: "#6B7280", fontSize: 13, marginTop: 2 }}>
                    {walletBalance.toFixed(0)} Coins available
                  </div>
                </div>
                <input
                  type="checkbox"
                  checked={useWallet}
                  onChange={(e) => setUseWallet(e.target.checked)}
                  style={{ transform: "scale(1.6)", cursor: "pointer", accentColor: "#006D77" }}
                />
              </div>
              {useWallet && (
                <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px dashed #D1D5DB" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}>
                    <span>Points Applied</span>
                    <span style={{ color: "#16A34A", fontWeight: 600 }}>
                      -{maxWalletPoints.toFixed(0)} Coins
                    </span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4, fontSize: 13, color: "#6B7280" }}>
                    <span>Discount Value</span>
                    <span>-₹{walletDeduction.toFixed(2)}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, fontSize: 13, color: "#6B7280" }}>
                    <span>Remaining Balance</span>
                    <span>{remainingWallet.toFixed(0)} Coins</span>
                  </div>
                </div>
              )}
            </div>
          )}

        {/* ─── Address Form ────────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <h2 style={{ ...styles.cardTitle, marginBottom: 0 }}>Delivery Details</h2>
            {isEditingAddress && (
              <button onClick={handleCancelEdit} style={styles.closeButton}>
                <X size={20} /><span>Close</span>
              </button>
            )}
          </div>

          {!isEditingAddress ? (
            <>
              <div style={styles.addressSummary}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}><strong>Name:</strong> {formData.full_name}</div>
                <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "4px" }}><strong>Mobile:</strong> {formData.phone}</div>
                <div style={{ fontSize: "14px", color: "#6B7280", lineHeight: "1.6" }}>
                  <strong>Community Name:</strong> {formData.community_name} <br />
                  <strong>Block:</strong> {formData.address_line1} <br />
                  {formData.address_line2 && <><strong>Flat No:</strong> {formData.address_line2} <br />
                  <strong>Pincode:</strong> {formData.pincode} <br /></>}
                </div>
              </div>
              <button onClick={handleEditAddress} style={styles.editButton}><Edit2 size={16} /> Edit Address</button>
            </>
          ) : (
            <>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Full Name <span style={styles.required}>*</span></label>
                <input type="text" readOnly={patientDetails?.patientType !== "new"}
                  style={{ ...styles.formInput, ...(errors.full_name ? styles.inputError : {}), backgroundColor: patientDetails?.patientType !== "new" ? "#F5F5F5" : "#fff" }}
                  placeholder="Enter your full name" value={formData.full_name} onChange={(e) => handleInputChange("full_name", e.target.value)} />
                {errors.full_name && <p style={styles.errorText}>{errors.full_name}</p>}
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Phone Number <span style={styles.required}>*</span></label>
                <input type="tel" readOnly={patientDetails?.patientType !== "new"}
                  style={{ ...styles.formInput, ...(errors.phone ? styles.inputError : {}), backgroundColor: patientDetails?.patientType !== "new" ? "#F5F5F5" : "#fff" }}
                  placeholder="Enter 10-digit phone number" value={formData.phone}
                  onChange={(e) => handleInputChange("phone", e.target.value.replace(/\D/g, "").slice(0, 10))} maxLength={10} />
                {errors.phone && <p style={styles.errorText}>{errors.phone}</p>}
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Community/Society Name <span style={styles.required}>*</span></label>
                <select style={{ ...styles.formInput, ...(errors.community_name ? styles.inputError : {}) }}
                  value={formData.community_name} onChange={(e) => handleInputChange("community_name", e.target.value)}>
                  <option value="">Select Community</option>
                  {communities.map((community) => <option key={community.name} value={community.name}>{community.name}</option>)}
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Block/Building <span style={styles.required}>*</span></label>
                <select style={{ ...styles.formInput, ...(errors.address_line1 ? styles.inputError : {}) }}
                  value={formData.address_line1} onChange={(e) => handleInputChange("address_line1", e.target.value)}>
                  <option value="">Select Block</option>
                  {BLOCK_OPTIONS.map((block) => <option key={block} value={block}>{block}</option>)}
                </select>
                {errors.address_line1 && <p style={styles.errorText}>{errors.address_line1}</p>}
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Flat/House Number</label>
                <input type="text" style={styles.formInput} placeholder="Flat or House Number"
                  value={formData.address_line2} onChange={(e) => handleInputChange("address_line2", e.target.value)} />
              </div>
              <div><label style={styles.label}>Pincode</label>
              <input type="text" style={styles.formInput} placeholder="Pincode"
                  value={formData.pincode} onChange={(e) => handleInputChange("pincode", e.target.value)} />
              </div>
              <button onClick={() => {setIsEditingAddress(false);handleSaveAddress(formData)}} style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "12px" }}>Save Address</button>
            </>
          )}
        </div>

        {/* ─── Delivery Time ───────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Preferred Delivery Time</h2>
          <div style={styles.inputGroup}>
            <div style={{ display: "flex", gap: "12px" }}>
              {["anytime", "specific"].map((option) => (
                <button key={option} type="button"
                  style={{ ...styles.addressTypeButton, ...(formData.delivery_time_option === option ? styles.addressTypeButtonActive : {}) }}
                  onClick={() => {
                    handleInputChange("delivery_time_option", option);
                    setSelectedDate(""); setSelectedSlot(""); setAvailableSlots([]);
                    setErrors(prev => ({ ...prev, selectedDate: "", delivery_time: "" }));
                  }}>
                  <span style={{ ...styles.addressTypeText, ...(formData.delivery_time_option === option ? styles.addressTypeTextActive : {}) }}>
                    {option === "anytime" ? "Anytime" : "Specific Time"}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {formData.delivery_time_option === "specific" && (
            <>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Select Date <span style={styles.required}>*</span></label>
                <input
                  type="date" value={selectedDate}
                  min={new Date().toISOString().split("T")[0]}
                  max={(() => { const d = new Date(); d.setDate(d.getDate() + 10); return d.toISOString().split("T")[0]; })()}
                  onChange={(e) => handleDateChange(e.target.value)}
                  onKeyDown={(e) => e.preventDefault()}
                  onClick={(e) => e.currentTarget.showPicker()}
                  style={{ ...styles.formInput, cursor: "pointer", ...(errors.selectedDate ? styles.inputError : {}) }}
                />
                {errors.selectedDate && <p style={styles.errorText}>{errors.selectedDate}</p>}
              </div>
              {selectedDate && availableSlots.length > 0 && (
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Available Time Slots <span style={styles.required}>*</span></label>
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {availableSlots.map((slot, index) => (
                      <button key={index} type="button" disabled={slot.disabled}
                        onClick={() => { setSelectedSlot(slot.label); handleInputChange("delivery_time", `${selectedDate} | ${slot.label}`); setErrors(prev => ({ ...prev, delivery_time: "" })); }}
                        style={{ padding: "12px", borderRadius: "12px", border: selectedSlot === slot.label ? "2px solid #006D77" : "1px solid #ccc", background: selectedSlot === slot.label ? "#006D77" : slot.disabled ? "#eee" : "#fff", color: selectedSlot === slot.label ? "#fff" : slot.disabled ? "#999" : "#333", cursor: slot.disabled ? "not-allowed" : "pointer", fontWeight: 600 }}>
                        ⏱ {slot.label} {slot.disabled ? "(Unavailable)" : ""}
                      </button>
                    ))}
                  </div>
                  {errors.delivery_time && <p style={styles.errorText}>{errors.delivery_time}</p>}
                </div>
              )}
            </>
          )}

          <div style={styles.deliverySummary}>
            <Clock size={20} color="#006D77" />
            <div style={styles.deliverySummaryContent}>
              <div style={styles.deliverySummaryLabel}>Selected Time:</div>
              <div style={styles.deliverySummaryValue}>
                {formData.delivery_time_option === "anytime" ? "Anytime (We will deliver at the earliest)" : formData.delivery_time || "Not selected"}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── Proceed Button ──────────────────────────────────────────────────── */}
      <div style={styles.buttonContainer}>
        <FormControlLabel style={{paddingBottom:16,display: "flex", justifyContent: "center", alignItems: "center",}}
              
              control={
                <Checkbox
                  size="small"
                  checked={acceptedTerms || false}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2">
                  Accept Ayuja's{" "}
                  <a href="/terms&conditions" target="_blank" rel="noopener noreferrer"
                    style={{ color: "#007a85", fontWeight: "bold", textDecoration: "none" }}>
                    Terms and Conditions
                  </a>
                    <span style={{ color: "red", marginLeft: 2 ,fontSize:19}}>*</span>
                </Typography>
              }
            />
        <button style={styles.proceedButton} onClick={handleProceed}  disabled={!acceptedTerms}
          onMouseEnter={(e) => (e.currentTarget.style.background = acceptedTerms ? "linear-gradient(90deg, #004F55 0%, #006D77 100%)":"#C4C4C4")}
          onMouseLeave={(e) => (e.currentTarget.style.background = acceptedTerms ? "linear-gradient(90deg, #006D77 0%, #00838F 100%)":"#C4C4C4")}>
          <span style={styles.proceedButtonText}>Proceed to Payment</span>
          <span style={styles.proceedButtonAmount}>₹{finalAmount.toFixed(2)}</span>
        </button>
      </div>

      <CustomDialog open={dialogOpen} message={dialogMessage} onClose={() => setDialogOpen(false)} />
    </div>
  );
};

export default MedicineDeliveryAddressScreen;